module.exports = __webpack_public_path__ + "media/images/city_img/t-2fd4f3828359280578ad569bda222185.jpg";